import React from 'react'
import AboutHeroSection from '../AboutUsPage/AboutHeroSection'
import ContactInfoSection from './ContactInfoSection'
import ContactFormSection from './ContactFormSection'
import ContactMapSection from './ContactMapSection'

const ContactPage = () => {
  return (
    <div>
              <AboutHeroSection pageName={"Contact Us"}/>
              <ContactInfoSection/>
              <ContactFormSection/>
              <ContactMapSection/>
              
    
    </div>
  )
}

export default ContactPage